import { render } from "./MotDirecteur.vue?vue&type=template&id=49d50864"
import script from "./MotDirecteur.vue?vue&type=script&lang=js"
export * from "./MotDirecteur.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__